module.exports = __webpack_public_path__ + "static/media/arrowexpanmodules.ad164bbc.svg";